import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Stripe } from '@capacitor-community/stripe';
import { StripeIdentity } from '@capacitor-community/stripe-identity';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { NotificationPushService } from './micro-services/notifications/services/notification-push.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'Inbox', url: '/folder/Inbox', icon: 'mail' },
    { title: 'Outbox', url: '/folder/Outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/Favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/Archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/Trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/Spam', icon: 'warning' },
  ];
  constructor(
        private notifService        : NotificationPushService
  ) {
    Stripe.initialize({
      publishableKey:
        'pk_test_51OmHoUBOlDTecqdbeRwbg6tIgc39hcyfdF8y75gZ8LJb51vxHAM4O8IZQgvbukQteBXMgTl4R6liaXtIbU00Rx8k00yy54cbJ1',
    });

    StripeIdentity.initialize({
      publishableKey:
        'pk_test_51OmHoUBOlDTecqdbeRwbg6tIgc39hcyfdF8y75gZ8LJb51vxHAM4O8IZQgvbukQteBXMgTl4R6liaXtIbU00Rx8k00yy54cbJ1',
    });

    this.notifService.addListeners();
    this.notifService.registerNotification();
  }
}
